export function setMenuPosition(element) {
    const screenWidth = window.visualViewport.width;
    const { right } = element.getBoundingClientRect();
    const overflow = screenWidth - right;
    if (right > screenWidth)
        element.style.left = overflow + "px";
}
